import React from 'react'

import { motion } from 'framer-motion';
import {AppWrap} from '../../wrapper';
import { images } from '../../constants';


import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => {
  return (
    <div className='app__header app__flex'>
      

      <motion.div
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.5, delayChildren: 0.5}}
        className="app__header-img"
      >
        
        <img src={images.PFR2022} alt="Prayers for Rain" />
        
      </motion.div>

      <motion.div
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.5, delayChildren: 0.5}}
        className="app__header-img"
      >

        <img src={images.WA2022} alt="Wildlife Analysis" />
        
      </motion.div>

      <motion.div
        whileInView={{opacity: [0, 1]}}
        transition={{duration: 0.5, delayChildren: 0.5}}
        className="app__header-img"
      >

        <img src={images.GC2022} alt="Garden of the Cardinal" />
        
      </motion.div>

     
    </div>
  )
}

export default AppWrap(Header, 'home');